import React from 'react';
import PropTypes from 'prop-types';
import FortellisDialog from './FortellisDialog';
import { FormattedMessage, injectIntl } from 'react-intl';
import { environmentURLs } from '../common/environment/CaptureEnvironment';
import ErrorCodes from '../common/ErrorCodes';

let isMarketplaceRequest = ({ response: { url = null } = {} }) => {
  return url ? url.startsWith(environmentURLs.marketplaceURL) : false;
};

const APIError = ({ error, dismiss }) => {
  if (!error) {
    return false;
  }

  let errorMessage = (
    <div>
      <FormattedMessage
        id="APIError.errorMessage1"
        defaultMessage="We’re unable to process your request. For details, contact support at "
      />

      <a href={'mailto:support@fortellis.io'} className="fortellis-link">
        {'support@fortellis.io'}&nbsp;
      </a>
    </div>
  );

  const setErrorMessage = message => {
    errorMessage = (
      <div>
        <FormattedMessage
          id="APIError.errorMessage1"
          defaultMessage="We’re unable to process your request. For details, contact support at "
        />
        <a href={'mailto:support@fortellis.io'} className="fortellis-link">
          {'support@fortellis.io'}&nbsp;
        </a>
        <hr />
        Error :&nbsp;
        {message}
      </div>
    );
  };

  for (let i = 0; i < error.length; i++) {
    // reload if marketplace /graphql return with status code
    if (
      error[i]['networkError'] &&
      error[i]['networkError']['statusCode'] === 403 &&
      isMarketplaceRequest(error[i]['networkError'])
    ) {
      window.location.reload();
      return null;
    }
    /*if (
      error[i]["message"] &&
      error[i]["message"].indexOf("Billing address is not available") > -1
    ) {
      errorMessage = (
          <FormattedMessage
              id="APIError.errorMessage2"
              defaultMessage="Billing address is not available. Please contact Fortellis Support."
          />
      )
    }*/
    if (
      error[i]['message'] &&
      error[i]['message'] === ErrorCodes.SOLUTION_WITH_SAME_NAME_ALREADY_EXISTS
    ) {
      errorMessage = (
        <FormattedMessage
          id="APIError.errorMessage3"
          defaultMessage="App with same name already exists. Please choose different name"
        />
      );
    }
    if (
      error[i]['message'] &&
      error[i]['message'] ===
        ErrorCodes.UNABLE_TO_FETCH_ORG_APPS_FROM_SOLUTION_SERVICE
    ) {
      return false;
    }

    if (
      error[i]['message'] &&
      error[i]['message'] === ErrorCodes.UTILIZATION_REPORT_NOT_FOUND
    ) {
      errorMessage = (
        <FormattedMessage
          id="APIUtilization.errorMessage"
          defaultMessage="Failed to get api utilization report for given app id, start date and end date. Please try again later"
        />
      );
    }

    if (
      JSON.stringify(error).includes('App') &&
      JSON.stringify(error).includes('does not exist')
    ) {
      errorMessage = (
        <FormattedMessage
          id="APIError.errorMessage4"
          defaultMessage="App does not exist"
        />
      );
    }

    if (JSON.stringify(error).includes('Subscription already exists')) {
      setErrorMessage(
        <FormattedMessage
          id="APIError.errorMessage5"
          defaultMessage=" Subscription already exists!"
        />
      );
    }
    if (
      JSON.stringify(error).includes(
        "Invalid state transition. Cannot 'Publish' already 'Revoked' solution"
      )
    ) {
      setErrorMessage(
        <FormattedMessage
          id="APIError.errorMessage6"
          defaultMessage="Invalid state transition. Cannot 'Publish' already 'Revoked' app"
        />
      );
    }

    if (
      JSON.stringify(error).includes(
        "Invalid state transition. Cannot 'Revoke' already 'Published' solution."
      )
    ) {
      setErrorMessage(
        <FormattedMessage
          id="APIError.errorMessage7"
          defaultMessage="Invalid state transition. Cannot 'Revoke' already 'Published' app."
        />
      );
    }

    if (
      JSON.stringify(error).includes(
        'Unable to fetch provider info for activation'
      ) ||
      JSON.stringify(error).includes(
        'Provider connection activation with old token failed'
      ) ||
      JSON.stringify(error).includes('Provider connection activation failed')
    ) {
      return false;
    }

    break;
  }

  return (
    <FortellisDialog
      customClassName="api-error-dialog"
      open={false}
      onAccept={dismiss}
      message={errorMessage}
    />
  );
};

APIError.propTypes = {
  error: PropTypes.any
};

export default injectIntl(APIError);
